import { TMeta } from '@cian/logger/shared';

import { fetchWebChatsGet, TWebChatsGetRequest, TWebChatsGetResponse } from '../../repositories/chats/v2/web/chats/get';
import { CHATS_ON_PAGE_LIMIT, EFilterBySyncChatSchema, EStatusSyncChatSchema } from '../../types/chatList';
import { TContext } from '../../types/context';
import { mapChatV2VersionToV1 } from '../../utils/v2ToV1/mapChat';

export interface IFetchChatsV2ParamsRequest {
  /** timestamp последнего чата, последней страницы */
  timestamp?: number;
  /** Фильтр для синхронизации чатов **/
  filterBy?: EFilterBySyncChatSchema;
  /** Раздел чатов **/
  status?: EStatusSyncChatSchema;
  subAgentRealtyUserId?: number;
}

type TFetchChatsV2Params = {
  parameters: IFetchChatsV2ParamsRequest;
  cookies?: string;
};

export async function fetchChatsV2({ logger, httpApi }: TContext, { cookies, parameters }: TFetchChatsV2Params) {
  const { timestamp, filterBy, status, subAgentRealtyUserId } = parameters;

  const options: TWebChatsGetRequest = {
    limit: CHATS_ON_PAGE_LIMIT,
    minDatetimeForSorting: timestamp ? new Date(timestamp).toISOString() : undefined,
    subAgentRealtyUserId,
    filterBy,
    status: status || EStatusSyncChatSchema.Active,
  };

  try {
    const { response, statusCode }: TWebChatsGetResponse = await fetchWebChatsGet({
      httpApi,
      parameters: options,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      logger.warning(
        String((response as unknown as TMeta).message) || /* istanbul ignore next */ 'Код ответа не равен 200',
        {
          domain: 'src/shared/services/fetchChatsV2.ts [fetchChatsV2]',
          message: 'Не удалось получить список чатов',
        },
      );

      return null;
    }

    return response.chats.map(mapChatV2VersionToV1) || [];
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchChatsV2.ts [fetchChatsV2]',
      message: 'Не удалось получить список чатов',
    });

    return null;
  }
}
